import { render, staticRenderFns } from "./StudentPhysiology.vue?vue&type=template&id=f5d0d180&"
import script from "./StudentPhysiology.js?vue&type=script&lang=js&"
export * from "./StudentPhysiology.js?vue&type=script&lang=js&"
import style0 from "./StudentPhysiology.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports